import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils';

export type RenewalNudge = {
  should_nudge: boolean;
  last_cp_end?: string;
};

export const renewalNudgeSchema: Schema<RenewalNudge> = z.object({
  should_nudge: z.boolean(),
  last_cp_end: cz.optional(z.string()),
});
